import { useState } from 'react';

export default function CtaSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const formActionUrl = 'https://api.readdy.ai/api/form/submit';

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = (formData.get('website_alt') as string || '').trim();
    if (honeypot) {
      setStatus('success');
      setMessage('订阅成功！请查收确认邮件。');
      setEmail('');
      return;
    }
    setStatus('loading');
    try {
      const res = await fetch(formActionUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
      });
      const responseText = await res.text();
      if (res.ok) {
        setStatus('success');
        setMessage('订阅成功！请查收确认邮件。');
        setEmail('');
      } else {
        setStatus('error');
        setMessage(responseText || '订阅失败，请稍后重试。');
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查连接后重试。');
    }
  };

  return (
    <section className="relative py-16 md:py-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20atmospheric%20Japanese%20ninja%20village%20at%20night%20with%20warm%20lantern%20lights%2C%20subtle%20red%20and%20orange%20glow%2C%20mysterious%20ambient%20mood%2C%20anime%20background%20style%2C%20soft%20bokeh%20effects&width=1600&height=600&seq=cta-bg-naruto&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/95 via-background-950/85 to-background-950/95"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-4">
          订阅火影黄漫导航更新
        </h2>
        <p className="text-foreground-300 text-sm md:text-base mb-8 max-w-lg mx-auto">
          第一时间获取最新火影同人资源更新、绘师推荐与社区资讯推送
        </p>

        {status === 'success' ? (
          <div className="bg-primary-500/20 border border-primary-400/30 rounded-xl p-6 max-w-md mx-auto">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
              <i className="ri-checkbox-circle-line text-3xl text-primary-400"></i>
            </div>
            <p className="text-foreground-100 font-semibold">{message}</p>
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
            data-readdy-form="newsletter-subscribe"
          >
            <input
              type="text"
              name="website_alt"
              tabIndex={-1}
              autoComplete="off"
              readOnly
              aria-hidden="true"
              className="honeypot-field"
            />
            <input
              type="email"
              name="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="输入你的邮箱地址"
              className="flex-1 px-5 py-3.5 bg-background-50/10 border border-foreground-300/20 rounded-lg text-foreground-100 placeholder:text-foreground-500 text-sm focus:outline-none focus:border-primary-400/50 transition-colors"
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-lg font-semibold text-sm hover:bg-primary-600 transition-all disabled:opacity-60 whitespace-nowrap"
            >
              {status === 'loading' ? '提交中...' : '立即订阅'}
            </button>
          </form>
        )}

        {status === 'error' && (
          <p className="text-red-400 text-xs mt-3">{message}</p>
        )}
      </div>
    </section>
  );
}